export default __webpack_public_path__ + "static/media/SpoqaHanSansNeo-Light.00827070.ttf";